import * as actions from './actionTypes';
import { setLoading, setMessage } from './general';
import axios from '../../config/axiosInstance';

export const fetchLocationsSuccess = locations => ({
  type: actions.FETCH_LOCATIONS_SUCCESS,
  locations,
});

export const fetchLocations = () => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .get('/location')
    .then((response) => {
      dispatch(fetchLocationsSuccess(response.data));
      dispatch(setLoading(false));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};

export const fetchLocationSuccess = locationData => ({
  type: actions.FETCH_LOCATION_SUCCESS,
  locationData,
});

export const fetchLocation = id => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .get(`/location/${id}`)
    .then((response) => {
      dispatch(fetchLocationSuccess(response.data));
      dispatch(setLoading(false));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};

export const createLocationSuccess = location => ({
  type: actions.CREATE_LOCATION_SUCCESS,
  data: location,
});

export const createLocation = location => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post('/location', location)
    .then((response) => {
      dispatch(createLocationSuccess(response));
      dispatch(setLoading(false));
      dispatch(setMessage('Local cadastrado com sucesso.'));
      return Promise.resolve(response);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      if (error === 'Erro de validação Location.lat cannot be null') {
        dispatch(setMessage('Necessário informar um endereço válido'));
      } else {
        dispatch(setMessage(error));
      }
      return Promise.reject(error);
    });
};

export const updateLocationsSuccess = location => ({
  type: actions.UPDATE_LOCATION_SUCCESS,
  data: location,
});

export const updateLocation = location => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .put('/location', location)
    .then((response) => {
      dispatch(updateLocationsSuccess(response));
      dispatch(setLoading(false));
      dispatch(setMessage('Local atualizado com sucesso.'));
      return Promise.resolve(response);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const deleteLocationSuccess = id => ({
  type: actions.DELETE_LOCATION_SUCCESS,
  id,
});

export const deleteLocation = id => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .delete(`/location/${id}`)
    .then(() => {
      dispatch(deleteLocationSuccess(id));
      dispatch(setLoading(false));
      dispatch(setMessage('Local excluído com sucesso.'));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};
